import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import { Text } from '@tcaster/tcaster-web-lib';

import { ScoreFormModal } from '../ScoreForm';
import { Button as TCButton } from '../../Components/Base';

const IconCalculate = styled(({ mini, ...restProps }) => (
  <i {...restProps} className={`tcst-calculate ${restProps.className}`} />
))`
  font-size: ${props => (props.mini ? 240 : 140)}%;
  vertical-align: middle;
  margin-right: ${props => (props.mini ? 0 : '4px')};
  line-height: 14px !important;
`;

class CalculateScoreButton extends Component {
  static propTypes = {
    title: PropTypes.string,
    mini: PropTypes.bool,
  };

  static defaultProps = {
    title: 'คำนวณคะแนน',
    mini: false,
  };

  render() {
    const { title, mini, ...restProps } = this.props;
    return (
      <ScoreFormModal
        trigger={
          mini ? (
            <TCButton inverted circular color="red" icon={<IconCalculate mini />} borderless />
          ) : (
            <Button
              inverted
              circular
              color="red"
              content={
                <Text style={{ fontWeight: 400, color: 'inherit' }}>
                  <IconCalculate />
                  {mini ? undefined : title}
                </Text>
              }
              {...restProps}
            />
          )
        }
      />
    );
  }
}

export default CalculateScoreButton;
